export default class Time {

    static YEARS_IN_SECONDS = 31536000;
    static DAYS_IN_SECONDS = 86400;
    static HOURS_IN_SECONDS = 3600;
    static MINUTES_IN_SECONDS = 60;

    static ageFormatter = (origin) => {

        const difference = this.distanceFromCurrentInSeconds(Date.parse(origin));

        if (difference > this.YEARS_IN_SECONDS) {

            const newCalc = Math.floor(difference / this.YEARS_IN_SECONDS);

            return (this.isMultipleOf(newCalc)) ? newCalc + " years" : newCalc + " year";
        } else if (difference >= this.DAYS_IN_SECONDS) {

            const newCalc = Math.floor(difference / this.DAYS_IN_SECONDS);

            return (this.isMultipleOf(newCalc)) ? newCalc + " days" : newCalc + " day";
        } else if (difference >= this.HOURS_IN_SECONDS) {

            const newCalc = Math.floor(difference / this.HOURS_IN_SECONDS);

            return (this.isMultipleOf(newCalc)) ? newCalc + " hours" : newCalc + " hour";
        } else if (difference >= this.MINUTES_IN_SECONDS) {

            const newCalc = Math.floor(difference / this.MINUTES_IN_SECONDS);

            return (this.isMultipleOf(newCalc)) ? newCalc + " minutes" : newCalc + " minute";
        } else {

            return (this.isMultipleOf(difference)) ? difference + " seconds" : difference + " second";
        }
    }

    static isMultipleOf = (recurrence) => {

        if (recurrence >= 2) return true;
        else false;
    }

    static distanceFromCurrentInSeconds = (origin) => {

        return Math.floor((Date.now() - origin) / 1000);
    }
}